import React, { useRef, useState } from 'react';

const PlaybackControls = ({ video, audioURL, videoRef, startTime, endTime, loopCount }) => {
  const audioRef = useRef(null);
  const [videoVolume, setVideoVolume] = useState(50);
  const [audioVolume, setAudioVolume] = useState(50);

  const handlePlaybackDubbed = () => {
    if (videoRef.current && audioRef.current) {
      let loopCounter = 0;
      const playSegment = () => {
        if (loopCounter < loopCount) {
          videoRef.current.seekTo(startTime);
          videoRef.current.playVideo();
          audioRef.current.currentTime = (endTime - startTime) * loopCounter;
          audioRef.current.play();

          setTimeout(() => {
            videoRef.current.pauseVideo();
            audioRef.current.pause();
            loopCounter++;
            if (loopCounter < loopCount) {
              playSegment();
            }
          }, (endTime - startTime) * 1000);
        } else {
          videoRef.current.pauseVideo();
          audioRef.current.pause();
        }
      };
      playSegment();
    }
  };

  const handleVideoVolumeChange = (e) => {
    const volume = e.target.value;
    setVideoVolume(volume);
    if (videoRef.current) {
      videoRef.current.setVolume(volume);
    }
  };

  const handleAudioVolumeChange = (e) => {
    const volume = e.target.value / 100;
    setAudioVolume(volume * 100);
    if (audioRef.current) {
      audioRef.current.volume = volume;
    }
  };

  return (
    <div className="controls">
      <button onClick={handlePlaybackDubbed}>Écoutez votre enregistrement</button>
      <div>
        <label>Volume Vidéo</label>
        <input type="range" min="0" max="100" value={videoVolume} onChange={handleVideoVolumeChange} />
      </div>
      <div>
        <label>Volume Enregistrement</label>
        <input type="range" min="0" max="100" value={audioVolume} onChange={handleAudioVolumeChange} />
      </div>
      <audio ref={audioRef} src={audioURL} controls />
    </div>
  );
};

export default PlaybackControls;
